import React from 'react';
import {observer} from 'mobx-react';
import {Trend} from "../../../trend/trend";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionOddsTrends = observer(({odds}) => {
  const trendProps = {
    trend: odds.trend,
    shouldRenderTrend: odds.shouldRenderTrend
  }

  return (
    odds.shouldRenderTrend ? <div className={classNames(styles.odds_trend)}>
      <Trend {...trendProps}/>
    </div> : null
  )
});
